import { Col, Container, Row } from 'react-bootstrap';
import { MailchimpForm } from './MailchimpForm';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';

export const Footer = () => (
  <footer className="footer">
    <Container>
      <Row className="align-items-center">
        <MailchimpForm />
        <Col xs={12} className="footer-meta text-center">
          <div className="social-icon">
            <a href="https://www.linkedin.com/company/assimilation-software" target="_blank" rel="noreferrer" aria-label="LinkedIn"><img src={navIcon1} alt="" /></a>
            <a href="https://www.facebook.com/AssimilationSoftware" target="_blank" rel="noreferrer" aria-label="Facebook"><img src={navIcon2} alt="" /></a>
            <a href="https://www.instagram.com/assimilation_software/" target="_blank" rel="noreferrer" aria-label="Instagram"><img src={navIcon3} alt="" /></a>
          </div>
          <p>Copyright {new Date().getFullYear()}. All Rights Reserved.</p>
        </Col>
      </Row>
    </Container>
  </footer>
);
